.event-item {
  --event-item-line-height: var(--rc-calendar-line-height);

  display: grid;
  position: relative;
  box-sizing: border-box;
  grid-template-columns: minmax(0, 1fr) auto;
  align-content: start;
  width: 100%;
  min-width: 0;
  padding: 0 6px;
  overflow: hidden;
  border: 0;
  border-radius: var(--rc-calendar-border-radius-base);
  color: var(--rc-calendar-color-text-heading);
  font-size: var(--rc-calendar-font-size-text-sm);
  text-align: start;
  cursor: pointer;
  pointer-events: auto;

  &.event-item-all-day {
    --event-item-line-height: calc(var(--rc-calendar-line-height) - 2px);

    width: calc(100% - 2px);
    margin-bottom: 1px;
    margin-left: 1px;
  }

  &.event-item-accepted {
    background-color: var(--rc-calendar-color-primary-background);
  }

  &.event-item-invited {
    border: var(--rc-calendar-border-width) var(--rc-calendar-border-style) var(--rc-calendar-color-primary-default);
    background-color: var(--rc-calendar-color-surface-default);
  }

  &.event-item-canceled {
    border: var(--rc-calendar-border-width) var(--rc-calendar-border-style) var(--rc-calendar-color-text-default);
    background-color: var(--rc-calendar-color-surface-default);

    .event-item-title {
      color: var(--rc-calendar-color-text-default);
      text-decoration: line-through;
    }

    .event-item-info {
      color: var(--rc-calendar-color-text-default);
    }
  }

  &.event-item-month {
    background-color: var(--rc-calendar-color-surface-default);
    color: var(--rc-calendar-color-text-heading);

    &.event-item-all-day {
      width: calc(100% - 1px);
      margin-bottom: 0;
      margin-left: 0;

      &.event-item-accepted:not(:focus) {
        background-color: var(--rc-calendar-color-primary-background);
      }
    }
  }

  .event-item-time {
    margin-right: var(--rc-calendar-spacing-xxxs);
    color: var(--rc-calendar-color-text-default);
    font-weight: var(--rc-calendar-font-weight-base);
  }

  &:focus {
    z-index: 2;
    background-color: var(--rc-calendar-color-primary-default);
    outline: none;

    .event-item-title {
      color: var(--rc-calendar-color-surface-default);
    }

    .event-item-info {
      color: var(--rc-calendar-color-surface-default);
    }

    .event-item-time {
      color: var(--rc-calendar-color-surface-default);
    }
  }

  &:not(.event-item-canceled)::before {
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 2px;
    box-sizing: border-box;
    width: 0;
    border: 1px var(--rc-calendar-color-primary-default);
    border-radius: var(--rc-calendar-border-radius-base);
    content: '';
  }

  &.event-item-invited::before {
    border-style: dashed;
  }

  &.event-item-accepted::before {
    border-style: solid;
  }

  &:is(.event-item-invited, .event-item-accepted):is(:active, :focus)::before {
    border-color: var(--rc-calendar-color-surface-default);
  }

  .event-item-title {
    grid-column: 1;
    min-width: 0;
    overflow: hidden;
    font-weight: var(--rc-calendar-font-weight-bold);
    line-height: var(--event-item-line-height);
    text-overflow: ellipsis;
    white-space: nowrap;

    &.event-item-title-multi-line {
      display: -webkit-box;
      word-break: break-word;
      white-space: normal;
      -webkit-box-orient: vertical;
    }
  }

  .event-item-info {
    grid-column: 1;
    overflow: hidden;
    color: var(--rc-calendar-color-text-default);
    line-height: var(--rc-calendar-line-height);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .event-item-icon {
    display: flex;
    grid-column: 2;
    grid-row: 1;
    align-items: center;
    align-self: start;
    height: var(--event-item-line-height);
    margin-left: var(--rc-calendar-spacing-xxs);

    :focus & {
      color: var(--rc-calendar-color-surface-default);
    }
  }
}
